export default __webpack_public_path__ + "static/media/a024-12.d17b2346.svg";